module.exports = __webpack_public_path__ + "static/antd-table-footer-8881ce831f09bb0bed14906778ee24df.png";